export default __webpack_public_path__ + "static/media/file.0fa4ebb3.svg";